module.exports = __webpack_public_path__ + "static/media/ECO2_OUTOFRANGE.3164ed20.png";